import React from 'react';
import { Wrapper, StyledSpinner } from './Spinner.styles';

const Spinner = ({ className }) => {
  return (
    <Wrapper className={className}>
      <StyledSpinner>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </StyledSpinner>
    </Wrapper>
  );
};

export default Spinner;
